import React from 'react';
import { createPortal } from 'react-dom';

interface FocusDurationPopoverProps {
  showDurationPopover: boolean;
  popoverPosition: { top: number; left: number } | null;
  onMouseEnterPopover: () => void;
  onMouseLeavePopover: () => void;
  onDurationSelect: (durationMinutes: number) => void;
  t: (key: string) => string;
}

/**
 * 专注模式持续时间选择弹窗组件
 * 显示持续时间选项并处理选择交互
 */
export const FocusDurationPopover: React.FC<FocusDurationPopoverProps> = ({
  showDurationPopover,
  popoverPosition,
  onMouseEnterPopover,
  onMouseLeavePopover,
  onDurationSelect,
  t
}) => {
  const DURATION_OPTIONS = [
    { label: t('v3/focus:time.minutes', { count: 10 }), minutes: 10 },
    { label: t('v3/focus:time.minutes', { count: 20 }), minutes: 20 },
    { label: t('v3/focus:time.minutes', { count: 30 }), minutes: 30 },
    { label: t('v3/focus:time.minutes', { count: 45 }), minutes: 45 },
    { label: t('v3/focus:time.hour', { count: 1 }), minutes: 60 },
  ];

  if (!showDurationPopover || !popoverPosition) return null;

  return createPortal(
    <div
      onMouseEnter={onMouseEnterPopover}
      onMouseLeave={onMouseLeavePopover}
      style={{
        position: 'fixed',
        top: `${popoverPosition.top}px`,
        left: `${popoverPosition.left}px`,
        transform: 'translate(-50%, -100%)',
        zIndex: 1000,
      }}
      className="w-max p-1.5 bg-neutral-700 dark:bg-neutral-800 shadow-xl rounded-lg flex flex-col space-y-0.5"
    >
      {DURATION_OPTIONS.map(opt => (
        <button
          key={opt.minutes}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onDurationSelect(opt.minutes);
          }}
          className="w-full text-left px-3 py-1.5 text-sm text-white hover:bg-neutral-600 dark:hover:bg-neutral-700 rounded-md transition-colors duration-150"
        >
          {opt.label}
        </button>
      ))}
    </div>,
    document.body
  );
};
